import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {getAuthenticationFlow} from '@vio/core/src/auth/modules/selectors'
import {AuthenticationFlows} from '@vio/core/src/auth/types/Auth'

const BottomSheetTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s100};
  text-align: center;
`

const titles = defineMessages({
  default: {
    id: 'magicLinkModal.titleMemberDeals',
    defaultMessage: 'Unlock member deals for FREE!'
  },
  [AuthenticationFlows.DealFreeze]: {
    id: 'dealFreeze.susiTitle',
    defaultMessage: 'Sign in to freeze this deal'
  },
  vioDeal: {
    id: 'vioDeals.unlock',
    defaultMessage: 'Unlock the best value'
  },
  [AuthenticationFlows.PostOfferCheck]: {
    id: 'lockedRoomOffer.susiTitle',
    defaultMessage: 'Sign in to book this deal'
  },
  [AuthenticationFlows.PreCheckout]: {
    id: 'SUSI.bookSmarter',
    defaultMessage: 'Sign in to book smarter'
  }
})

const descriptions = defineMessages({
  default: {
    id: 'SUSI.joinMembers',
    defaultMessage:
      'Join over 5,000,000 members who are saving on every booking'
  },
  [AuthenticationFlows.DealFreeze]: {
    id: 'dealFreeze.susiDescription',
    defaultMessage:
      'Secure the price and availability of this stay – no card details required.'
  },
  vioDeal: {
    id: 'vioDeals.getFreeAccess',
    defaultMessage:
      'Sign up to {brandName} to get free access to insider hotel deals and save up to 45% on your stays.'
  },
  [AuthenticationFlows.PostOfferCheck]: {
    id: 'lockedRoomOffer.susiDescription',
    defaultMessage:
      'Book this deal and discover thousands more exclusive market-beating discounts.'
  },
  [AuthenticationFlows.PreCheckout]: {
    id: 'SUSI.saveTime',
    defaultMessage:
      'Save time when booking, get hotel price alerts, and manage all your bookings in one places.'
  }
})

const getTitleMessage = (flow: AuthenticationFlows | null) => {
  switch (flow) {
    case AuthenticationFlows.DealFreeze:
    case AuthenticationFlows.PostOfferCheck:
    case AuthenticationFlows.PreCheckout:
      return titles[flow]
  }

  return titles.vioDeal
}

const getDescriptionMessage = (flow: AuthenticationFlows | null) => {
  switch (flow) {
    case AuthenticationFlows.DealFreeze:
    case AuthenticationFlows.PostOfferCheck:
    case AuthenticationFlows.PreCheckout:
      return descriptions[flow]
  }

  return descriptions.vioDeal
}

export const SignInTitle = () => {
  const {formatMessage} = useIntl()
  const authenticationFlow = useSelector(getAuthenticationFlow)
  const {brandName} = useBrand()

  const title = formatMessage(getTitleMessage(authenticationFlow))
  const description = formatMessage(getDescriptionMessage(authenticationFlow), {
    brandName
  })

  return (
    <BottomSheetTitle>
      <Text variant="titleXL" dataId="vioDeals.unlock">
        {title}
      </Text>
      <div>
        <Text>{description}</Text>
      </div>
    </BottomSheetTitle>
  )
}
